var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarClusterYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.281.456a1 1 0 011 1v1h1a1 1 0 010 2h-1v1a1 1 0 01-2 0v-1h-1a1 1 0 010-2h1v-1a1 1 0 011-1zm0 10a1 1 0 011 1v1h1a1 1 0 010 2h-1v1a1 1 0 11-2 0v-1h-1a1 1 0 110-2h1v-1a1 1 0 011-1zm7-10a1 1 0 01.967.744l1.179 4.456 3.354 1.934a1 1 0 010 1.732l-3.354 1.935-1.18 4.455a1 1 0 01-1.933 0l-1.179-4.456-3.354-1.934a1 1 0 010-1.732l3.354-1.935L9.315 1.2a1 1 0 01.966-.744z",
    fill: "#F0D35B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarClusterYellow);
export default __webpack_public_path__ + "static/media/star-cluster-yellow.1678b4e0fc21e47c559d0b2d9c714427.svg";
export { ForwardRef as ReactComponent };